import { useState } from 'react';
import { Navigate } from 'react-router-dom';

import { Loader } from '@hivebrite/design-system/Loader';
import { useAsyncEffect } from '@hivebrite/react-hooks';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { CART_ITEM_TYPES } from 'hb-react/shared/components/ShoppingCard/constants/cartConstants';
import { useShoppingCard } from 'hb-react/shared/components/ShoppingCard/hooks/useShoppingCard';
import { useQueryParams } from 'hb-react/shared/hooks/useQueryParams';

const getOrderPagePath = ({ id, topicContext }) => {
  if (topicContext?.topicId) {
    return Routes.topic_memberships_order_path(topicContext.topicId, id);
  }

  return Routes.memberships_order_path(id);
};

const CreateCart = () => {
  const topicContext = useTopicContext();
  const [cartId, setCartId] = useState();
  const { currency, id, type = CART_ITEM_TYPES.MEMBERSHIP } = useQueryParams();

  const {
    actions: { create },
  } = useShoppingCard();

  useAsyncEffect(async () => {
    if (!id || !currency) {
      return;
    }

    const {
      data: { cart },
    } = await create({
      cart_items: [{ type, id, currency: { id: currency } }],
    });

    setCartId(cart.id);
  }, [currency, id, type]);

  if (!cartId) {
    return <Loader size={32} />;
  }

  return <Navigate to={getOrderPagePath({ id: cartId, topicContext })} />;
};

export default CreateCart;
